import { useAppContext } from "../AppContext";

const useGlobalState = paths => {
  const { state } = useAppContext();
  if (!paths) {
    return state;
  }

  const pathSplit = paths.split(".");
  const res = pathSplit.reduce((acc, path) => acc && acc[path], state);

  return res;
};

export default useGlobalState;
